export default __webpack_public_path__ + "static/media/board.05f54509.svg";